import VoidedApplicationsContainer from "../../../Components/Applications/VoidedApplications";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const VoidedApplications = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Voided Applications";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin"]}
      />

      {/* Main content */}
      <VoidedApplicationsContainer/>
    </>
  );
};

export default VoidedApplications;
